import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  project: ProjectVenue;
};

export const editProjectVenue = createAppAsyncThunk(
  'projectVenue/editProjectVenue',
  async (
    params: Params,
    { extra: { projectVenueGateway, snackbarGateway } },
  ): Promise<void> => {
    try {
      await projectVenueGateway.edit(params.project);
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('EditProject.Message.error'));
}

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('EditProject.Message.success'));
}
